import React, { useState, useEffect } from "react";
import { Button, Typography, Box, Paper, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import LogoPuntu from "../../../assets/images/logo-puntu.png";
import ImageTopo from "../../../assets/images/img-topo.png";
import ImageWpp from "../../../assets/images/img-wpp.png";
import { Dialog } from "@material-ui/core";
import axios from "../../../config/axiosInstance";
import { usageLog } from "../../../store/actions/globalActions";
import zIndex from "@mui/material/styles/zIndex";

// Definindo as cores como variáveis
const colors = {
  principal: "#003f91",
  textoOferta: "#ffc107",
  hexagonoP: "#0c125b",
  hexaganoG: "#00218d",
  txtsec: "#ffc107",
  texto: "#ffff",
  Texto: "#ffc107",
  texto2: "#3a3a3a",
  texto3: "#82470f",
};

// Objeto de estilos

const Popup = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [countdown, setCountdown] = useState("");
  const [isHoveredHexagon1, setIsHoveredHexagon1] = useState(false);
  const [isHoveredHexagon2, setIsHoveredHexagon2] = useState(false);
  const companyId = JSON.parse(localStorage.getItem("companies"));

  useEffect(() => {
    searchOpenModal();
  }, []);
  const addVariable = () => {
    const url = new URL(window.location);
    url.searchParams.set("promocaoPuntu", true);
    window.history.pushState({}, "", url);
  };

  const searchOpenModal = async () => {
    return
    try {
      const response = await axios.get("/warning");
      // TODO JEAN REFATORAR ESSA LOGICA
      const isPremium = response.data?.isPremium
        ? response.data?.isPremium
        : true;
      const hasTicketAvaliable = response.data?.hasTicketAvaliable
        ? !response.data?.hasTicketAvaliable
        : false;

      if (isPremium && !response.data?.isTrial && !hasTicketAvaliable) {
        return;
      } else {
        setIsVisible(true);
        addVariable();
        usageLog(
          "warning/modal/WhatsApp/Promocao",
          companyId[0].companyId,
          companyId[0].byUser
        );
      }
    } catch (error) {
      console.log(error);
    }
  };

  const targetDate = new Date("2025-02-07T00:00:00").getTime();

  const updateCountdown = () => {
    const now = new Date().getTime();
    const timeRemaining = targetDate - now;

    const days = Math.floor(timeRemaining / (1000 * 60 * 60 * 24));
    const hours = Math.floor(
      (timeRemaining % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
    );
    const minutes = Math.floor(
      (timeRemaining % (1000 * 60 * 60)) / (1000 * 60)
    );
    const seconds = Math.floor((timeRemaining % (1000 * 60)) / 1000);

    setCountdown(`${days}d ${hours}h ${minutes}m ${seconds}s`);
  };

  useEffect(() => {
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);

  const handleClose = () => {
    setIsVisible(false);
  };

  const handleMouseEnterHexagon1 = () => {
    setIsHoveredHexagon1(true);
  };

  const handleMouseLeaveHexagon1 = () => {
    setIsHoveredHexagon1(false);
  };

  const handleMouseEnterHexagon2 = () => {
    setIsHoveredHexagon2(true);
  };

  const handleMouseLeaveHexagon2 = () => {
    setIsHoveredHexagon2(false);
  };

  return (
    <Dialog
      open={isVisible}
      onClose={handleClose}
      PaperProps={{
        style: {
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-46%, -58%)",
          width: 650,
          height: 600,
          padding: "20px",
          backgroundColor: "#363dc9",
          borderRadius: "20px",
          overflow: "hidden",
        },
      }}
      scroll="body"
    >
      {/* <Box sx={styles.popupContainer}> */}
      {/* <Paper sx={styles.popupContent}> */}
      <Typography sx={styles.textFimpromo}>
        <p className="textoFimPromos" style={styles.textoFimpromo}>
          🔥Prorrogamos, só até sexta 07/02: {countdown}🔥
        </p>
        <IconButton sx={styles.popupClose} onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </Typography>
      <Box style={styles.img}>
        <Box sx={styles.logoImg}>
          <img src={LogoPuntu} alt="Logo" style={styles.logoPuntu} />
        </Box>
        <Box sx={styles.imgTopo}>
          <img
            src={ImageTopo}
            alt="Imagem secundária"
            style={styles.imgSecundaria}
          />
        </Box>
        <Box
          sx={styles.hexagono1}
          onMouseEnter={handleMouseEnterHexagon1}
          onMouseLeave={handleMouseLeaveHexagon1}
        >
          <Typography sx={styles.hexText}>
            <div className="hex-text">
              {isHoveredHexagon1 ? (
                <p className="text2-hex1" style={styles.hexText}>
                  Confira já as exclusividades do Plano Premium
                </p>
              ) : (
                // Exibe este texto quando o mouse estiver sobre o hexágono
                <p style={styles.hexText}>
                  Queremos te ajudar a ter um 2025 mais prático e simples. Pare
                  você focar no que realmente importa.
                </p> // Exibe o texto original
              )}
            </div>
          </Typography>
        </Box>
      </Box>
      <Typography style={styles.qtdFun}>
        <p style={{ marginTop: "-10px" }}>Planos e preços:</p>
      </Typography>
      <Box sx={styles.hexagonoContainer}>
        <Box
          sx={styles.hexagono2}
          onMouseEnter={handleMouseEnterHexagon2}
          onMouseLeave={handleMouseLeaveHexagon2}
        >
          <Typography sx={styles.hexText}>
            <div className="hex-text2">
              {isHoveredHexagon2 ? (
                <p style={{ ...styles.hexText, fontSize: "15px" }}>
                  Mais de 1500 empresas já aproveitaram essa oportunidade e
                  garantiram o desconto exclusivo – não fique de fora dessa!"
                </p> // Exibe este texto quando o mouse estiver sobre o hexágono
              ) : (
                <>
                  <p style={styles.textP1}>Até</p>
                  <p style={styles.textNumb}>69%</p>
                  <p style={styles.textP2}>de desconto no seu plano!</p>
                </>
              )}
            </div>
          </Typography>
        </Box>
      </Box>
      <Box style={styles.elements}>
        <div style={styles.qtdFunBotao}>
          <Button
            style={styles.qtdFunBotaoButton}
            onClick={() =>
              window.open(
                "https://app.puntu.digital/assinatura?plan=Premium&Pagamento=false&Cupom=OFERTA27"
              )
            }
          >
            <a
              href="https://app.puntu.digital/assinatura?plan=Premium&Pagamento=false&Cupom=OFERTA27"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "inherit",
                fontSize: "15px",
              }}
            >
              Até 6 Funcionários: R$27/mês
            </a>
          </Button>
          <div className="Btndestaque" style={styles.Btndestaque}>
            <p className="TextDestaque" style={styles.TextDestaque}>
              🏅 Faça como a maioria 🏅{" "}
            </p>
            <Button
              style={styles.qtdFunBotaoButton2}
              onClick={() =>
                window.open(
                  "https://app.puntu.digital/assinatura?plan=Premium&Pagamento=false&Cupom=OFERTA47"
                )
              }
            >
              <a
                href="https://app.puntu.digital/assinatura?plan=Premium&Pagamento=false&Cupom=OFERTA47"
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textDecoration: "none",
                  color: "inherit",
                  fontSize: "15px",
                }}
              >
                De 6 a 16 funcionários: R$47/mês
              </a>
            </Button>
          </div>
          <Button
            style={styles.qtdFunBotaoButton3}
            onClick={() =>
              window.open(
                "https://app.puntu.digital/assinatura?plan=Premium&Pagamento=false&Cupom=OFERTA67"
              )
            }
          >
            <a
              href="https://app.puntu.digital/assinatura?plan=Premium&Pagamento=false&Cupom=OFERTA67"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                textDecoration: "none",
                color: "inherit",
                fontSize: "15px",
              }}
            >
              Mais de 16 funcionários: R$67/mês
            </a>
          </Button>
        </div>
        <div style={styles.cttGabi}>
          <Button
            style={styles.numGabi}
            onClick={() => window.open("https://wa.me/61991466572")}
          >
            <img src={ImageWpp} alt="Imagem Whatsapp" style={styles.imgWpp} />
            <a
              href="https://wa.me/61991466572"
              target="_blank"
              rel="noopener noreferrer"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <p className="txt-wpp">Fale conosco</p>
            </a>
          </Button>
        </div>
      </Box>
      {/*

                */}
      {/* </Paper> */}
      {/* </Box> */}
    </Dialog>
  );
};

export default Popup;

const styles = {
  img: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: "20px",
    marginLeft: "-50px",
    marginTop: "-85px",
  },
  popupContainer: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: 1000,
  },
  popupContent: {
    backgroundColor: "#363dc9",
    borderRadius: "20px",
    padding: "200px",
    position: "relative",
    textAlign: "center",
    width: "100%",
    height: "200px",
    overflow: "hidden",
  },
  textFimpromo: {
    marginTop: "-20px",
    width: "600px",
    height: "35px",
    backgroundColor: "#0d8527",
    fontSize: "21px",
    color: colors.texto,
    fontWeight: "bold",
    marginLeft: "-20px",
    borderTopLeftRadius: "20px",
    borderTopRightRadius: "20px",
    AlignItems: "center",
    justifyContent: "center",
    textAlign: "left",
    display: "flex",
    zIndex: 10000,
  },
  textoFimpromo: {
    marginLeft: "-30px",
    marginTop: "0px",
  },
  popupClose: {
    position: "absolute",
    top: "-5px",
    right: "10px",
    border: "none",
    background: "none",
    fontWeight: "100",
    fontSize: "40px",
    cursor: "pointer",
    color: "#ffff",
    zIndex: 10000,
  },
  imgTopo: {
    marginTop: "70px",
    marginRight: "-160px",
  },
  imgSecundaria: {
    // margin: "272%",
    width: "106px",
    marginLeft: "-160px",
    // marginBottom: "-108%",
  },
  logoImg: {
    marginTop: "-30px",
    // marginBottom: "10%",
  },
  logoPuntu: {
    // marginTop: "-180px",
    // marginLeft: "-225%",
    width: "165px",
    height: "auto",
  },
  hexagonoContainer: {
    position: "relative",
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    gap: "20px",
    marginLeft: "15px",
  },
  hexagono: {
    width: "300px",
    height: "300px",
    backgroundColor: "#6c6c6c",
    clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
    transition: "transform 0.3s ease",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  hexagono1: {
    // marginRight: "-97px",
    // marginTop: "-80px",
    top: "0",
    width: "300px",
    height: "300px",
    backgroundColor: colors.hexaganoG,
    display: "flex",
    order: "1",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: colors.txtsec,
    fontFamily: "Montserrat",
    fontWeight: "200",
    padding: "10px",
    boxShadow: "100px 4px 6px rgba(0, 0, 0, 0.2)",
    clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
    marginTop: "53px",
    zIndex: -1,
  },
  hexagono2: {
    marginTop: "-440px",
    marginLeft: "260px",
    marginRight: "20px",
    width: "250px",
    height: "250px",
    backgroundColor: colors.hexagonoP,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    textAlign: "center",
    color: colors.Texto,
    fontWeight: "bold",
    padding: "10px",
    boxShadow: "10px 14px 16px rgba(0, 0, 0, 0.2)",
    clipPath: "polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)",
  },
  hexText: {
    fontSize: "20px",
    fontWeight: "bold",
    margin: 0,
    padding: 0,
  },
  textP1: {
    fontFamily: "Courier New, monospace",
    margin: "-20%",
    marginLeft: "-25%",
    marginTop: "10px",
    marginBottom: "-5px",
    fontWeight: "medium",
    fontSize: "20px",
  },
  textNumb: {
    color: colors.Texto,
    fontFamily: "Montserrat",
    marginTop: "-17%",
    fontSize: "75px",
    fontWeight: "900",
  },
  textP2: {
    fontFamily: "Montserrat",
    marginTop: "-88px",
    fontSize: "13px",
    fontWeight: "600",
  },
  cont: {
    position: "absolute",
    color: colors.texto,
    top: "-2px",
    left: "10px",
    border: "none",
    background: "none",
    fontSize: "24px",
    zIndex: 1100,
    fontWeight: "bolder",
    cursor: "pointer",
  },
  elements: {
    // marginLeft: "-80%",
    width: "275px",
    height: "70px",
    marginRight: "auto",
    marginTop: "-95px",
    display: "flex",
  },
  qtdFun: {
    zIndex: 1000,
    backgroundColor: "white",
    color: colors.principal,
    fontSize: "20px",
    fontWeight: "bolder",
    borderTopRightRadius: "50px",
    width: "270px",
    height: "30px",
    textAlign: "center",
    marginLeft: "-20px",
    marginTop: "-36px",
  },

  Btndestaque: {
    background: "linear-gradient(90deg, #ff8c00, #ff4500)",
    width: "255px",
    height: "80px",
    padding: "19px",
    borderRadius: "20px",
    display: "webkit box",
    marginBottom: "20px",
    marginTop: "-77px",
  },
  TextDestaque: {
    color: "#ffff",
    marginTop: "-18px",
    marginBottom: "0px",
    fontWeight: "bold",
    fontSize: "14px",
    textAlign: "center",
  },

  qtdFunBotao: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    gap: "15px",
    // margin: "20px auto",
    marginTop: "-220px",
    marginLeft: "-15px",
  },

  qtdFunBotaoButton2: {
    width: "250px",
    height: "60px",
    backgroundColor: "#fecf00",
    color: "#221c9d",
    border: "none",
    marginBottom: "15px",
    marginLeft: "-17px",
    borderRadius: "12px",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    boxShadow: "0 5px 10px rgb(243, 109, 0)",
    cursor: "pointer",
    transition: "transform 0.2s ease, background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#ffc200",
      transform: "translateY(-5px)",
    },
  },

  qtdFunBotaoButton3: {
    width: "250px",
    height: "60px",
    backgroundColor: "#fecf00",
    color: "#221c9d",
    border: "none",
    marginBottom: "15px",
    marginTop: "-17px",
    marginLeft: "0px",
    borderRadius: "12px",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    boxShadow: "0 5px 10px rgb(243, 109, 0)",
    cursor: "pointer",
    transition: "transform 0.2s ease, background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#ffc200",
      transform: "translateY(-5px)",
    },
  },

  qtdFunBotaoButton: {
    width: "250px",
    height: "60px",
    backgroundColor: "#fecf00",
    color: "#221c9d",
    border: "none",
    marginBottom: "80px",
    borderRadius: "12px",
    marginTop: "-215px",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    boxShadow: "0 5px 10px rgb(243, 109, 0)",
    cursor: "pointer",
    transition: "transform 0.2s ease, background-color 0.2s ease",
    "&:hover": {
      backgroundColor: "#ffc200",
      transform: "translateY(-5px)",
    },
  },
  cttGabi: {
    width: "980px",
    margin: "20px auto",
  },
  numGabi: {
    marginLeft: "68px",
    marginTop: "-263px",
    display: "flex",
    alignItems: "center",
    width: "250px",
    height: "30px",
    backgroundColor: "#0d8527",
    color: "#ffffff",
    border: "none",
    borderRadius: "12px",
    fontSize: "18px",
    fontWeight: "bold",
    textAlign: "center",
    boxShadow: "0 5px 10px rgb(85, 210, 35)",
    cursor: "pointer",
    transition: "transform 0.2s ease, background-color 0.2s ease",
    justifyContent: "center",
  },
  imgWpp: {
    // marginLeft: "13%",
    marginTop: "-1%",
    width: "45px",
    height: "auto",
  },
};
